export const siteConfig = {
  name: "校园爆料",
  brandAlt: "校园爆料·怪谈求证",
  slogan: "求证校园怪谈，还原旧事真相",
  description: "一个专注求证「校园怪谈是真的吗」的简体中文内容站，深挖学校未解传闻、梳理校园旧事档案、还原校园传言的真相。",
  keywords: ["校园怪谈是真的吗", "学校未解传闻", "校园旧事档案", "校园传言的真相", "校园爆料"],
  established: "2020",
  contactEmail: "editor@xybaoliao.example.com",
  contactNote: "投稿邮箱：把你听过的校园传说与亲历细节发给我们，一起求证。",
};

export const siteNav = [
  { key: "home", label: "首页", path: "/" },
  { key: "archive", label: "怪谈档案库", path: "/archive" },
  { key: "about", label: "求证方式", path: "/about" },
  { key: "faq", label: "常见疑问", path: "/about#faq" },
];

export const faqList = [
  {
    q: "校园怪谈是真的吗？为什么要做求证？",
    a: "我们不对「真伪」下绝对结论，而是把传闻拆成可核实的时间、地点与人物线索，对照校史、公开档案与多人证言。很多怪谈源于真实事件的记忆变形——旧建筑、意外事故、年代久远的管理规定，经过口口相传后披上灵异外衣。求证的价值在于让怪谈回归其最初的人与事。",
  },
  {
    q: "学校未解传闻的线索从哪里来？",
    a: "主要来自四类来源：校友投稿与亲历者口述、地方校志与校史资料、旧报刊与地方档案、以及校园论坛和早年贴吧的讨论记录。每条传闻我们都会标注来源性质，方便读者判断可信度。",
  },
  {
    q: "为什么有些旧事档案查不到明确答案？",
    a: "年代久远的校园往事往往缺乏书面记录，亲历者记忆也会随年代模糊。查不到答案并不等于传说为真或为假，而是证据不足。对于这类档案，我们会明确标注「证据不足、存疑待考」，而不是强行给出猜测。",
  },
  {
    q: "校园传言的真相和你想象中的一样吗？",
    a: "多数情况下，真相比传说更平淡，却也更有温度——可能是守夜老师的例行巡查，可能是老校工点的一盏灯，也可能是某次真实事故留下的集体记忆。我们坚持用线索说话，不渲染恐怖，也不轻易否定一段集体记忆的价值。",
  },
  {
    q: "我听到过一个校园怪谈，想投稿该怎么做？",
    a: "欢迎投稿。请在投稿中尽可能写明：发生年代、学校类型与大概地区、你听说的完整经过、消息来源（亲历/转述/论坛）。我们会保护你的隐私，仅公开匿名化的线索。投稿请发送至站内邮箱或通过联系表单提交。",
  },
  {
    q: "求证内容是否会涉及真实人名与学校隐私？",
    a: "我们坚持新闻伦理：涉及真实人物一律化名处理，涉及在校师生与具体在校生的事件，在官方未披露前不做主观判断，仅做传闻梳理与证据陈列。未成年与在校学生的线索绝不含敏感指向。",
  },
];

export const verifyRules = [
  { step: "01", title: "线索采集", desc: "整理传说的版本与细节差异，记录口述者年代与角色，建立最早的传闻出处。" },
  { step: "02", title: "时间对表", desc: "把传说涉及的时间点与校史沿革、建筑建成年代一一比对，剔除明显失真之处。" },
  { step: "03", title: "多方交叉", desc: "寻找不同年代的校友、管理者与目击者证言，比对说法是否相互印证。" },
  { step: "04", title: "结论分级", desc: "按「有据可考 / 有历史原型 / 证据不足存疑 / 基本可证为误传」四档给出求证结论。" },
];